import colors from '../../_shared/colors';

export default {
  container: `
    align-items: center;
    justify-content: center;
  `,
  formContainer: `
    width: 1000px;
    max-width: 1000px;

    .ant-table-bordered .ant-table-tbody > tr > td {
      border-bottom: 1px solid #e8e8e8;
    }
  `,
  alertMargin: `
    margin-bottom: 40px;
  `,
  buttonContainer: `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0;
  `,
  subText: `
    background-color: ${colors.disabledLight};
    font-size: 12px;
    text-align: left;
    padding: 2px 5px;
  `,
  button: `
    margin: 5px;
  `,
  uploadContainer: `
    width: 80%;
  `,
  divider: `
    font-weight: bold;
    color: ${colors.highlight};
  `,
  dlTemplate: `
    position: absolute;
    left: 10px;
    top: 10px;
  `
}